import Vue from 'vue';
import { assign, has, get, isArray } from 'lodash';
import * as api from 'api/api-stuff-to-eat';
import * as types from '../mutation-types';

const initState = {
  fetching: false,
  fetched: true,
  search: false,
  error: null,
  saving: false,
  saveError: false,
  meta: {},
  data: {},
};

const neutralState = {
  fetching: false,
  fetched: true,
  saving: false,
  empty: false,
  saveError: null,
  error: null,
  notFound: null,
};

const state = {};

const getters = {
  StuffToEatContent: state => entityContentID => state[entityContentID],
};

const actions = {
  GetStuffToEatContent({ commit }, params) {
    const id = params.id;
    const type = params.type;
    const entityContentID = params.entityContentID;
    commit(types.FETCH_STUFF_TO_EAT_CONTENT_START, { entityContentID });
    api.getContent(
      type,
      id,
      entityContentID,
      (response) => {
        commit(types.RECEIVE_STUFF_TO_EAT_CONTENT, { entityContentID, response });
      },
      (description, status, error) => {
        commit(types.FETCH_STUFF_TO_EAT_CONTENT_ERROR, { entityContentID, error });
      },
    );
  },
  InitStuffToEatContent({ commit }, params) {
    const entityContentID = params.entityContentID;
    commit(types.CLEAR_STUFF_TO_EAT_CONTENT, { entityContentID });
  },
  AddStuffToEatContent({ dispatch, commit }, params) {
    console.log('AddStuffToEatContent', params);
    return new Promise((resolve, reject) => {
      const id = params.id;
      const type = params.type;
      const data = params.data;
      const entityContentID = params.entityContentID;
      commit(types.SAVE_STUFF_TO_EAT_CONTENT_START, { entityContentID });
      api.addContent(
        type,
        id,
        data,
        (response) => {
          commit(types.SAVE_STUFF_TO_EAT_CONTENT_SUCCESSFUL, { entityContentID, response });
          dispatch('AddStuffToEatContentToContentsList', { id, response });
          dispatch('SyncStuffToEatDetailsNutritionInfo', { id, type });
          resolve(true);
        },
        (description, status, saveError) => {
          commit(types.SAVE_STUFF_TO_EAT_CONTENT_ERROR, { entityContentID, saveError });
          reject(saveError);
        },
      );
    });
  },
  UpdateStuffToEatContent({ dispatch, commit }, params) {
    console.log('EditStuffToEatContent', params);
    return new Promise((resolve, reject) => {
      const id = params.id;
      const type = params.type;
      const data = params.data;
      const entityContentID = params.entityContentID;
      commit(types.UPDATE_STUFF_TO_EAT_CONTENT_START, { entityContentID });
      api.updateContent(
        type,
        id,
        entityContentID,
        data,
        (response) => {
          commit(types.UPDATE_STUFF_TO_EAT_CONTENT_SUCCESSFUL, { entityContentID, response });
          dispatch('UpdateStuffToEatContentInContentsList', { id, response });
          dispatch('SyncStuffToEatDetailsNutritionInfo', { id, type });
          resolve(true);
        },
        (description, status, saveError) => {
          commit(types.UPDATE_STUFF_TO_EAT_CONTENT_ERROR, { entityContentID, saveError });
          reject(saveError);
        },
      );
    });
  },
  RemoveStuffToEatContent({ dispatch, commit }, params) {
    console.log('RemoveStuffToEatContent', params);
    return new Promise((resolve, reject) => {
      const id = params.id;
      const type = params.type;
      const entityContentID = params.entityContentID;
      commit(types.REMOVE_STUFF_TO_EAT_CONTENT_START, { entityContentID });
      api.removeContent(
        type,
        id,
        entityContentID,
        () => {
          commit(types.REMOVE_STUFF_TO_EAT_CONTENT_SUCCESSFUL, { entityContentID });
          dispatch('RemoveStuffToEatContentFromContentsList', { id, entityContentID });
          dispatch('SyncStuffToEatDetailsNutritionInfo', { id, type });
          resolve(true);
        },
        (description, status, saveError) => {
          commit(types.REMOVE_STUFF_TO_EAT_CONTENT_ERROR, { entityContentID, saveError });
          reject(saveError);
        },
      );
    });
  },
  AddStuffToEatContentServingSizeToServingSizeList({ commit }, { entityContentID, response }) {
    commit(types.ADD_STUFF_TO_EAT_CONTENT_SERVING_SIZE_TO_SERVING_SIZE_LIST, { entityContentID, response });
  },
  ClearStuffToEatContent({ commit }, { entityContentID }) {
    commit(types.CLEAR_STUFF_TO_EAT_CONTENT, { entityContentID });
  },
};

const mutations = {
  [types.FETCH_STUFF_TO_EAT_CONTENT_START](state, { entityContentID }) {
    console.log('FETCH_STUFF_TO_EAT_CONTENT_START');
    if (has(state, entityContentID)) Vue.set(state, entityContentID, assign({}, neutralState, { fetching: true }));
    else Vue.set(state, entityContentID, assign({}, initState, { fetching: true }));
  },
  [types.FETCH_STUFF_TO_EAT_CONTENT_ERROR](state, { entityContentID, error }) {
    console.log('FETCH_STUFF_TO_EAT_CONTENT_ERROR');
    Vue.set(state, entityContentID, assign(state[entityContentID], neutralState, { error }));
  },
  [types.RECEIVE_STUFF_TO_EAT_CONTENT](state, { entityContentID, response }) {
    console.log('RECEIVE_STUFF_TO_EAT_CONTENT', entityContentID, response);
    Vue.set(state, entityContentID, assign(state[entityContentID], neutralState, { ready: true, data: response.data, meta: response.meta }));
  },

  [types.CLEAR_STUFF_TO_EAT_CONTENT](state, { entityContentID }) {
    console.log('CLEAR_STUFF_TO_EAT_CONTENT', entityContentID);
    Vue.set(state, entityContentID, assign({}, initState));
  },

  [types.SAVE_STUFF_TO_EAT_CONTENT_START](state, { entityContentID }) {
    console.log('SAVE_STUFF_TO_EAT_CONTENT_START');
    Vue.set(state, entityContentID, assign(state[entityContentID], neutralState, { saving: true }));
  },
  [types.SAVE_STUFF_TO_EAT_CONTENT_ERROR](state, { entityContentID, saveError }) {
    console.log('SAVE_STUFF_TO_EAT_CONTENT_ERROR');
    Vue.set(state, entityContentID, assign(state[entityContentID], neutralState, { saveError }));
  },
  [types.SAVE_STUFF_TO_EAT_CONTENT_SUCCESSFUL](state, { entityContentID, response }) {
    console.log('SAVE_STUFF_TO_EAT_CONTENT_SUCCESSFUL', response);
    Vue.set(state, entityContentID, assign(state[entityContentID], neutralState, { data: response.data }));
  },

  [types.UPDATE_STUFF_TO_EAT_CONTENT_START](state, { entityContentID }) {
    console.log('UPDATE_STUFF_TO_EAT_CONTENT_START');
    Vue.set(state, entityContentID, assign(state[entityContentID], neutralState, { saving: true }));
  },
  [types.UPDATE_STUFF_TO_EAT_CONTENT_SUCCESSFUL](state, { entityContentID, response }) {
    console.log('UPDATE_STUFF_TO_EAT_CONTENT_SUCCESSFUL', response);
    Vue.set(state, entityContentID, assign(state[entityContentID], neutralState));
  },
  [types.UPDATE_STUFF_TO_EAT_CONTENT_ERROR](state, { entityContentID, saveError }) {
    console.log('SAVE_STUFF_TO_EAT_CONTENT_ERROR');
    Vue.set(state, entityContentID, assign(state[entityContentID], neutralState, { saveError }));
  },

  [types.REMOVE_STUFF_TO_EAT_CONTENT_START](state, { entityContentID }) {
    console.log('REMOVE_STUFF_TO_EAT_CONTENT_START');
    Vue.set(state, entityContentID, assign(state[entityContentID], neutralState, { saving: true }));
  },
  [types.REMOVE_STUFF_TO_EAT_CONTENT_SUCCESSFUL](state, { entityContentID }) {
    console.log('REMOVE_STUFF_TO_EAT_CONTENT_SUCCESSFUL', entityContentID);
    Vue.set(state, entityContentID, assign({}, initState));
  },
  [types.REMOVE_STUFF_TO_EAT_CONTENT_ERROR](state, { entityContentID, saveError }) {
    console.log('REMOVE_STUFF_TO_EAT_CONTENT_ERROR');
    Vue.set(state, entityContentID, assign(state[entityContentID], neutralState, { saveError }));
  },

  [types.ADD_STUFF_TO_EAT_CONTENT_SERVING_SIZE_TO_SERVING_SIZE_LIST](state, { entityContentID, response }) {
    console.log('ADD_STUFF_TO_EAT_CONTENT_SERVING_SIZE_TO_SERVING_SIZE_LIST', entityContentID, response);
    const entityServingSizes = get(state[entityContentID], 'data.Content.EntityServingSizes');
    const userAddedList = get(entityServingSizes, 'available_serving.user_added.list');
    if (isArray(userAddedList)) {
      userAddedList.push(response.data);
      Vue.set(entityServingSizes, 'selected_serving', response.data);
    }
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/stuff-to-eat/entities/stuff-to-eat-content.js